import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
// import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

export default function AlertDialog(props) {
  return (
    <div>
      <Dialog
        open={props.open}
        onClose={props.handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {props.edit ? "Success!" : "Congratulations!"}
          {props.open ? (
            <IconButton
              aria-label="close"
              onClick={props.handleClose}
              sx={{
                position: "absolute",
                right: 8,
                top: 8,
                color: (theme) => theme.palette.grey[500],
              }}
            >
              <CloseIcon />
            </IconButton>
          ) : null}
        </DialogTitle>
        <DialogContent>
          <DialogContentText
            id="alert-dialog-description"
            sx={{ fontWeight: 600, mb: 1 }}
          >
            {props.edit
              ? "Organizational account updated."
              : "A new place as been created"}
          </DialogContentText>
          <DialogContentText id="alert-dialog-description">
            {props.edit
              ? `Your organizational account has successfully been updated.`
              : ``}
          </DialogContentText>
        </DialogContent>
        <DialogActions
          sx={
            {
              // justifyContent: "space-between",
            }
          }
        >
          <Button onClick={props.handleClose} variant="contained">
            Ok
          </Button>
          {/* <Button onClick={props.handleClose} variant="contained">
            Cancel
          </Button> */}
        </DialogActions>
      </Dialog>
    </div>
  );
}
